import { Button } from "@/components/ui/button";
import { useScrollReveal } from "@/hooks/useScrollReveal";

const FinalCTA = () => {
  const ref = useScrollReveal();

  const scrollToHero = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section ref={ref} className="py-10 md:py-16 px-4">
      <div className="max-w-xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-3">
          Find out if AI recommends your brand
        </h2>
        <p className="text-muted-foreground mb-8">
          Free. Research-backed. No signup required.
        </p>
        <Button onClick={scrollToHero} size="lg" className="font-semibold px-8">
          Scan Now
        </Button>
      </div>
    </section>
  );
};

export default FinalCTA;
